export function getTierName(tiersOrId, maybeId) {
  // Support two call styles for backwards compatibility:
  //  - getTierName(tiers, tierId)
  //  - getTierName(tierId)
  let tiers = [];
  let tierId = maybeId;

  if (maybeId === undefined) {
    tierId = tiersOrId;
  } else {
    tiers = Array.isArray(tiersOrId) ? tiersOrId : [];
  }

  /* c8 ignore next */
  const tier = Array.isArray(tiers) ? tiers.find((t) => t.id === tierId) : undefined;
  return tier ? tier.name : 'Unknown';
}

export default { getTierName };
